module.exports = pratt.PrattSharedLibs.instantsearch.middlewares;